import { Component, OnInit } from '@angular/core';
import { ToasterServiceService } from '../../service/toaster.service';
import { Location } from '@angular/common';
import { MainService } from '../../service/main.service';
import { environment } from '../../../environments/environment';
import { ApiUrls } from '../../apiRouts';

@Component({
  selector: 'app-activist',
  templateUrl: './activist.component.html',
  styleUrl: './activist.component.scss'
})
export class ActivistComponent implements OnInit{
  baseUrl = environment.imageURL;
  activistListData: any;
  allMemberData: any[] = [];
  originalMemberListData: any[] = [];
  activistAllListData: any[] = [];

  constructor(
    private toasterService: ToasterServiceService,
    private location: Location,
    private mainService: MainService) {
  }

  ngOnInit() {
    this.getActivistMember();
    this.getAllMember();
  }

  goBackToPrevPage() {
    this.location.back();
  }

  searchMember(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.getActivistMember();
      this.getAllMember();
      this.allMemberData = [...this.originalMemberListData];
      this.activistListData = [...this.activistAllListData];
      return;
    }
    this.activistListData = this.activistAllListData.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue) ||
        data.contact_no.includes(filterValue);
    });
    this.allMemberData = this.originalMemberListData.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue) ||
        data.contact_no.includes(filterValue);
    });
  }

  getActivistMember() {
    this.mainService.getApi(ApiUrls.allMemberList).subscribe((res: any) => {
      if (res.status == 1) {
        const members = res.user;
        const filteredMembers = members.filter((member: any) => {
          return member.is_verified === 1 || member.is_verified === 0;
        });
        this.activistListData = filteredMembers;
        this.activistAllListData = filteredMembers;
      }
    });
  }

  getAllMember() {
    this.mainService.getApi(ApiUrls.allMemberList).subscribe((res: any) => {
      if (res.status == 1) {
        const members = res.user;
        const filteredMembers = members.filter((member: any) => {
          return member.is_verified == 1;
        });
        this.allMemberData = filteredMembers;
        this.originalMemberListData = filteredMembers;
      }
    });
  }

  UpdateStatus(selectedValue: string, member: any) {
    let data = {
      user_id: member.user_id,
      name: "",
      address: "",
      contact_no: "",
      whatsapp_no: "",
      business: "",
      office_contact: "",
      office_address: "",
      village_id: 0,
      current_city_id: 0,
      education: "",
      dob: "",
      blood_group: "",
      image: "", // Assuming 'image' is a property of the member object
      //image_file:"",
      relation_id: 0,
      main_member_id: 0,
      maternal_name: "",
      maternal_village_id: 0,
      is_verified: 0,
      user_type_id: parseInt(selectedValue, 10),// Convert selectedValue to integer if necessary
      password: "",
      created_by: 0,
      Action: 'USERTYPE'
    };
    if (member.is_verified === 1) {
      this.mainService.putApi(ApiUrls.verifiedMemberList, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.getActivistMember();
        } else {
          this.toasterService.toastError(res.response);
        }
      });
    }
  }



}
